import { render, staticRenderFns } from "./CreateDegradingPotentialForTax.vue?vue&type=template&id=1707b29a&scoped=true&"
import script from "./CreateDegradingPotentialForTax.vue?vue&type=script&lang=js&"
export * from "./CreateDegradingPotentialForTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1707b29a",
  null
  
)

export default component.exports